import { DB } from './database';

export async function logUnitEvent(unitId, unitType, event, details, user) {
  const ev = {
    id: DB.genId('EVT'),
    unit_id: unitId,
    unit_type: unitType,
    event,
    details: details || {},
    actor_id: user?.id || null,
    actor_role: user?.role || null,
    created_at: new Date().toISOString(),
  };
  const list = DB.get('unitEvents') || [];
  const result = await DB.setAsync('unitEvents', [...list, ev]);
  if (result?.error) { console.error('[logUnitEvent] Failed:', result.error); }
  return ev;
}

export function getUnitEvents(unitId) {
  return (DB.get('unitEvents') || []).filter(e => e.unit_id === unitId);
}
